export const AVATAR_SIZES = {
  small: 20,
  medium: 28,
  large: 32,
};

export const getAvatarStyle = (size = 'medium') => {
  const px = AVATAR_SIZES[size] || AVATAR_SIZES.medium;
  return { width: `${px}px`, height: `${px}px`, borderRadius: '50%' };
};


